/**
 * Redux Selectors with Memoization (using reselect)
 * These prevent unnecessary component re-renders by memoizing selector results
 */

import { createSelector } from 'reselect';
import { RootState } from './store';

// Base selectors
const selectNavigationState = (state: RootState) => state.navigationdata;
const selectUserdataState = (state: RootState) => state.userdata;
const selectCreditsState = (state: RootState) => state.creditsData;

// Navigation selectors
export const selectModalData = createSelector([selectNavigationState], (navigation) => navigation.modalData);

export const selectToastData = createSelector([selectNavigationState], (navigation) => navigation.toastData);

export const selectLoading = createSelector([selectNavigationState], (navigation) => navigation.loading);

export const selectIsModalOpen = createSelector([selectModalData], (modalData) => modalData.open);

export const selectModalBody = createSelector([selectModalData], (modalData) => modalData.body);

// Userdata selectors
export const selectUsername = createSelector([selectUserdataState], (userdata) => userdata.username);

export const selectUserId = createSelector([selectUserdataState], (userdata) => userdata.userId);

export const selectUserData = createSelector([selectUsername, selectUserId], (username, userId) => ({
  username,
  userId,
}));

// Credits selectors
export const selectCreditsData = createSelector([selectCreditsState], (credits) => credits);

export const selectCredits = createSelector([selectCreditsState], (credits) => credits.Credits);

export const selectSelectedCredit = createSelector([selectCreditsState], (credits) => credits.selectedCredit);

export const selectMora = createSelector([selectCreditsState], (credits) => credits.Mora);
